<template>
  <div class="section-header">
    <div class="section-label">{{ label }}</div>
    <h2 class="section-title">{{ title }}</h2>
    <p v-if="subtitle" class="section-sub">{{ subtitle }}</p>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
});
</script>

<style scoped>
.section-header { margin-bottom: 2.5rem; }
.section-label {
  display: inline-block; background: rgba(91,95,239,.08);
  color: #5B5FEF; border: 1px solid rgba(91,95,239,.2);
  border-radius: 99px; padding: .3rem 1rem;
  font-size: .8rem; font-weight: 700; margin-bottom: 1rem;
}
.section-title {
  font-size: clamp(1.6rem,3vw,2.2rem); font-weight: 800;
  color: #111827; margin-bottom: 0; line-height: 1.3;
}
.section-sub { font-size: .92rem; color: #6B7280; margin-top: .4rem; }
</style>
